import { useState } from 'react';
import { ChatEventsContainer } from '@trinity/chat-components/components/Chat/Chat.Events.Container';
import { ChatSessionEndGuard } from '@trinity/chat-components/components/Chat/Chat.SessionEndGuard';
import { SubmitChatActionContainer } from '@trinity/chat-components/components/Chat/Chat.SubmitAction.Container';
import { UploadFilesContainer } from '@trinity/chat-components/components/Chat/Chat.UploadFiles.Container';
import {
  MessagesListRefContext,
} from '@trinity/chat-components/components/Chat/context';
import { ChatScrollContainer } from '@trinity/chat-components/components/Chat/ScrollContainer';
import { QueryFeedbackModalContainer } from '@trinity/chat-components/components/Chat.Feedback';
import { GetStartedContainer } from '@trinity/chat-components/components/Chat.GetStarted';
import { ChatHistoryContainer } from '@trinity/chat-components/components/Chat.History';
import { ChatTabsContainer } from '@trinity/chat-components/components/Chat.History/Chat.Tabs.Container';
import { RateLimitingContainer } from '@trinity/chat-components/containers/RateLimiting';
import { TopLevelTTSContainer } from '@trinity/chat-components/containers/TextToSpeechAudioPlayer/Container';
import { LoadingVoiceClipContainer } from '@trinity/chat-components/containers/TextToSpeechAudioPlayer/LoadingVoiceClips.Container';
import { ChatHintsContainer } from '../Chat/Chat.Hints.Container';
import { ChatPermissionsContainer } from '../Chat/Chat.Permissions.Container';
import { RegenerateMessageContainer } from '../Chat/Chat.Regenerate.Container';
import { SubmitMessageContainer } from '../Chat/Chat.Submit.Container';
import { VariantMessageContainer } from '../Chat/Chat.Variant.Container';
import { ChatSettingsContainer } from '../Chat.Screen/Chat.Setting';
import { InputControlsContainer } from './InputControl.Container';
import { SidebarContainer } from './Sidebar.Container';
import { SidePanelContainer } from './SidePanel.Container';
import { LandingCardsContainer } from '../Chat/LandingCards.Container';

type Props = {
  children: React.ReactNode;
};

/*
  IMPORTANT: These are all the containers needed for the chat experience.
  They should be common to the modal/screen and not be tied to a single app
*/

export const ChatContainer = (props: Props) => {
  const [messagesRef, setMessagesRef] = useState<HTMLDivElement>(null);

  return (
    <RateLimitingContainer>
      <ChatSettingsContainer>
        <MessagesListRefContext.Provider value={[messagesRef, setMessagesRef]}>
          <ChatScrollContainer>
            <GetStartedContainer>
              <SidebarContainer>
                <SidePanelContainer>
                  <QueryFeedbackModalContainer>
                    <ChatHistoryContainer>
                      <ChatTabsContainer>
                        <ChatPermissionsContainer>
                          <SubmitMessageContainer>
                            <SubmitChatActionContainer>
                              <RegenerateMessageContainer>
                                <VariantMessageContainer>
                                  <ChatHintsContainer>
                                    <LoadingVoiceClipContainer>
                                      <TopLevelTTSContainer>
                                        <InputControlsContainer>
                                          <ChatSessionEndGuard>
                                            <ChatEventsContainer>
                                              <UploadFilesContainer>
                                                <LandingCardsContainer>
                                                  {props.children}
                                                </LandingCardsContainer>
                                              </UploadFilesContainer>
                                            </ChatEventsContainer>
                                          </ChatSessionEndGuard>
                                        </InputControlsContainer>
                                      </TopLevelTTSContainer>
                                    </LoadingVoiceClipContainer>
                                  </ChatHintsContainer>
                                </VariantMessageContainer>
                              </RegenerateMessageContainer>
                            </SubmitChatActionContainer>
                          </SubmitMessageContainer>
                        </ChatPermissionsContainer>
                      </ChatTabsContainer>
                    </ChatHistoryContainer>
                  </QueryFeedbackModalContainer>
                </SidePanelContainer>
              </SidebarContainer>
            </GetStartedContainer>
          </ChatScrollContainer>
        </MessagesListRefContext.Provider>
      </ChatSettingsContainer>
    </RateLimitingContainer>
  );
};
